<template>
  <v-card>
    <v-card-text>
      <v-container fluid grid-list-md>
        <v-layout wrap row>
          <v-flex xs6>
            <v-text-field
              label="From"
              type="number"
              v-model="convertBox.valueFrom"
            />
            <select-currency @change="selectCurrency" mode="from" :defaultCountry="countryFrom" />
          </v-flex>
          <v-flex xs6>
            <v-text-field
              label="To"
              type="number"
              v-model="convertBox.valueTo"
            />
            <select-currency @change="selectCurrency" mode="to" />
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import SelectCurrency from './SelectCurrency'
import currencyHelper from '../../helper/currency'

export default {
  props: ['countryFrom'],
  components: {
    SelectCurrency
  },
  data: () => ({
    convertBox: {
      countryFrom: 'USD',
      countryTo: 'USD',
      valueFrom: null,
      valueTo: null
    }
  }),
  computed: {
    currencies () {
      return this.$store.state.currencies
    }
  },
  watch: {
    convertBox: {
      deep: true,
      handler () {
        let data = this.convertBox
        this.convertBox.valueTo = currencyHelper.convert(data.countryFrom, data.countryTo, data.valueFrom)
      }
    }
  },
  methods: {
    selectCurrency (country, mode) {
      if (mode == 'from') {
        this.convertBox.countryFrom = country
      } else {
        this.convertBox.countryTo = country
      }
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/converter/ConvertBox.vue